import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Cell,
  CartesianGrid,
} from "recharts";

interface ConfidenceHistogramProps {
  data: Array<{ bucket: string; count: number }>;
}

function bucketColor(index: number, total: number): string {
  // Gradient from red (low confidence) to green (high confidence)
  const t = total > 1 ? index / (total - 1) : 1;
  const r = Math.round(220 * (1 - t) + 34 * t);
  const g = Math.round(38 * (1 - t) + 197 * t);
  const b = Math.round(38 * (1 - t) + 94 * t);
  return `rgb(${r}, ${g}, ${b})`;
}

export function ConfidenceHistogram({ data }: ConfidenceHistogramProps) {
  if (!data.length || data.every((d) => d.count === 0)) {
    return (
      <div className="flex h-[300px] items-center justify-center text-sm text-muted-foreground">
        No data yet
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={data}>
        <CartesianGrid strokeDasharray="3 3" className="stroke-border" />
        <XAxis
          dataKey="bucket"
          tick={{ fontSize: 11 }}
          className="text-muted-foreground"
        />
        <YAxis tick={{ fontSize: 12 }} className="text-muted-foreground" />
        <Tooltip
          contentStyle={{
            backgroundColor: "hsl(var(--popover))",
            border: "1px solid hsl(var(--border))",
            borderRadius: "6px",
            color: "hsl(var(--popover-foreground))",
          }}
        />
        <Bar dataKey="count" radius={[4, 4, 0, 0]}>
          {data.map((_, i) => (
            <Cell key={i} fill={bucketColor(i, data.length)} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
}
